import { DEFAULT_LANGUAGE } from 'app-constants';
import { LocalStorageService as LocalStorageServiceOriginal } from 'hyarchis-global/services';
import { JobOutput } from 'types';
import { SettingsState } from 'store/settings';
import { DocumentGroup } from '../../types/documentGroup';

export enum Item {
  drawerWidth = 'drawerWidth',
  settings = 'settings',
  jobOutputs = 'jobOutputs',
  documents = 'documents',
  groups = 'groups',
}

class LocalStorageService extends LocalStorageServiceOriginal {
  constructor() {
    super(DEFAULT_LANGUAGE);
  }

  updateDrawerWidth(newWidth: number) {
    localStorage.setItem(Item.drawerWidth, `${newWidth}`);
  }

  getDrawerWidth() {
    const drawerWidth = localStorage.getItem(Item.drawerWidth);

    if (drawerWidth) {
      return +drawerWidth;
    }

    return undefined;
  }

  getSettings() {
    return this.parseJson(localStorage.getItem(Item.settings)) as SettingsState;
  }

  updateSettings(settings: SettingsState) {
    localStorage.setItem(Item.settings, JSON.stringify(settings));
  }

  getJobOutputs() {
    return this.parseJson(localStorage.getItem(Item.jobOutputs)) as JobOutput[];
  }

  updateJobOutputs(jobOutputs: JobOutput[]) {
    localStorage.setItem(Item.jobOutputs, JSON.stringify(jobOutputs));
  }

  getDocuments() {
    return this.parseJson(localStorage.getItem(Item.documents)) as JobOutput[];
  }

  updateDocuments(documents: JobOutput[]) {
    localStorage.setItem(Item.documents, JSON.stringify(documents));
  }

  getGroups() {
    return this.parseJson(localStorage.getItem(Item.groups)) as DocumentGroup[];
  }

  updateGroups(documentGroups: DocumentGroup[]) {
    localStorage.setItem(Item.groups, JSON.stringify(documentGroups));
  }
}

export default new LocalStorageService();
